const styles = (themeColor) => ({
    subtitle: {
        fontSize: '1rem',
        textTransform: 'uppercase',
    },
    h1: {
        fontSize: '3rem',
        fontWeight: 'bold',
        marginTop: '0',
        marginBottom: '2.25rem',
    },
    h2: {
        fontSize: '3.25rem',
        marginTop: '0',
        marginBottom: '1.8rem',
    },
    h3: {
        fontSize: '2.25rem',
        marginTop: '0',
        marginBottom: '1.5rem',
        lineHeight: '1rem'
    },
    h4: {
        fontSize: '1.5rem',
        marginTop: '0',
        marginBottom: '.75rem',
    },
    h5: {
        fontSize: '1.25rem',
        marginTop: '0',
        marginBottom: '.4rem',
    },
    h6: {
        fontSize: '1rem',
        marginTop: '0',
        marginBottom: '1rem',
        textTransform: 'uppercase'
    },
    p: {
        fontSize: '1rem',
        marginTop: '0',
        marginBottom: '1rem',
        lineHeight: '2rem',
    },
    li: {
        lineHeight: '2rem',
    },
    liText: {
        fontSize: '1rem',
        marginTop: 0,
        marginBottom: 0,
        marginLeft: '10px',
        lineHeight: '2rem',
    },
    ul: {
        marginTop: 0,
        marginBottom: '.75rem',
        paddingLeft: 0,
        textIndent: '-10px',
    },
    document: {
        lineHeight: '2rem',
    },
    a: {
        backgroundColor: themeColor,
        color: 'white',
        padding: '0rem .9rem',
        margin: '0 .25rem',
        borderRadius: '20px',
        fontSize: '.9rem',
        display: 'inline-block'
    },
    hr: {
        borderTop: '1px solid lightgray'
    }
})

export default styles;
